import NavRoutes from './NavRoutes';
import NavRoutesContainer from './NavRoutes.container';

export default NavRoutesContainer(NavRoutes);
